import { User } from './user';

export type EpiControlType = 'descartavel' | 'reutilizavel' | 'por_condicao';

export const EPI_CONTROL_TYPE_OPTIONS: {
  value: EpiControlType;
  label: string;
  description: string;
}[] = [
  {
    value: 'descartavel',
    label: 'Descartável',
    description: 'Controla quantidade/fornecimento. Sem prazo fixo de troca.',
  },
  {
    value: 'reutilizavel',
    label: 'Reutilizável com prazo',
    description: 'Sistema gera previsão de troca pelo prazo em dias.',
  },
  {
    value: 'por_condicao',
    label: 'Substituição por condição',
    description: 'Sem data fixa; troca por desgaste ou avaliação.',
  },
];

export type Epi = {
  id: number;
  name: string;
  controlType?: EpiControlType | string;
  category?: string;
  brand?: string;
  ca?: string;
  caExpirationDate?: string;
  supplier?: string;
  size?: string;
  stock?: number;
  minimumStock?: number;
  replacementPeriodDays?: number;
  sectors?: string;
  isActive: boolean;
  createdAt: string;
};

export type EmployeeEpi = {
  id: number;
  employee: Employee;
  epi: Epi;
  createdAt: string;
  lastDeliveredAt?: string;
};

export enum EpiDeliveryReason {
  ADMISSION = 'admissao',
  REPLACEMENT = 'reposicao',
  WEAR = 'troca_por_desgaste',
  LOSS = 'perda_extravio',
  ROLE_CHANGE = 'mudanca_de_funcao',
  PERIODIC = 'entrega_periodica',
}

export const EpiDeliveryReasonLabel: Record<string, string> = {
  admissao: 'Admissão',
  reposicao: 'Reposição',
  troca_por_desgaste: 'Troca por desgaste',
  perda_extravio: 'Perda/Extravio',
  mudanca_de_funcao: 'Mudança de função',
  entrega_periodica: 'Entrega periódica',
};

export const EpiDeliveryReasonOptions = Object.entries(
  EpiDeliveryReasonLabel,
).map(([value, label]) => ({ value, label }));

export type EpiDelivery = {
  id: number;
  employee: Employee;
  epi: Epi;
  reason: string | null;
  quantity: number;
  createdAt: string;
};

export enum EmployeePeriod {
  DAY = 'day',
  NIGHT = 'night',
}

export type Employee = {
  id: number;
  user: User;
  paymentPrice?: string;
  transportPrice?: string;
  needTransport: boolean;
  documentRG?: string;
  documentCPF?: string;
  documentPIS?: string;
  period: EmployeePeriod;
  addressZipCode?: string;
  addressStreet?: string;
  addressNumber?: string;
  addressCity?: string;
  note?: string;
  company?: number;
  workScale?: number;
  supervisor?: number;
  feedback?: string;
  dismissedAt?: Date;
  salary?: string;
  email?: string;
  epis?: EmployeeEpi[];
  sector?: string;
};

export type SectorEpiRequirement = {
  id: number;
  sector: string;
  epi: Epi;
  required: boolean;
  createdAt: string;
};

export type GroupedEpiRecord = {
  id: number;
  epi: {
    id: number;
    name: string;
    ca?: string | null;
    brand?: string | null;
    category?: string | null;
    controlType?: string | null;
    replacementPeriodDays?: number | null;
    isActive: boolean;
  };
  lastDeliveredAt: string | null;
  createdAt: string;
};

export type GroupedEmployee = {
  id: number;
  employeeName: string;
  sector: string;
  role: string;
  companyId: number | null;
  epis: GroupedEpiRecord[];
};

export type EpiDeadlineItem = {
  linkId: number;
  employeeId: number;
  employeeName: string;
  sector: string | null;
  epiId: number;
  epiName: string;
  replacementPeriodDays: number;
  lastDeliveredAt: string;
  nextDueDate: string;
  daysUntilDue: number;
};
